import BaseService from './BaseService'

class AppEngineService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  getFacebookPages = (locationId: string) => this.requests.get(`/facebook/get_pages/${locationId}`)
}

const instance = new AppEngineService(BaseService.servicesConfig.AppEngine)

export default instance